module.exports = __webpack_public_path__ + "static/media/Neutral.f45fe151.png";